/**
 * Vue客服插件
 * 提供在Vue组件中使用客服功能的便捷方法
 */

import { loadChatbotGlobally, showChatbot, hideChatbot, isChatbotLoaded } from '@/utils/chatbot.js'

export default {
  install(Vue) {
    // 添加全局方法
    Vue.prototype.$loadChatbotGlobally = loadChatbotGlobally;
    Vue.prototype.$showChatbot = showChatbot;
    Vue.prototype.$hideChatbot = hideChatbot;
    Vue.prototype.$isChatbotLoaded = isChatbotLoaded;

    // 创建全局状态
    Vue.prototype.$chatbotState = {
      lastRoute: null,
      isProcessing: false
    };

    // 添加全局混入
    Vue.mixin({
      methods: {
        /**
         * 初始化全局客服插件（只加载一次）
         * @param {Object} config - 配置选项
         */
        initChatbot(config = {}) {
          // 获取当前路由信息
          const currentRoute = this.$route?.name || this.$route?.path;

          // 默认配置
          const defaultConfig = {
            token: 'R4oJsHKHPTbXLVmH',
            inputs: {
              // 可以在这里添加页面相关的输入变量
              page: currentRoute
            },
            systemVariables: {},
            userVariables: {}
          };

          // 合并配置
          const finalConfig = {
            ...defaultConfig,
            ...config,
            inputs: { ...defaultConfig.inputs, ...(config.inputs || {}) }
          };

          // 全局加载客服插件
          loadChatbotGlobally(finalConfig);
        },

        /**
         * 显示客服插件
         */
        showChatbot() {
          showChatbot();
        },

        /**
         * 隐藏客服插件
         */
        hideChatbot() {
          hideChatbot();
        },

        /**
         * 根据当前路由更新客服插件显示状态
         */
        updateChatbotVisibility() {
          const currentRoute = this.$route?.name;

          // 避免重复处理相同路由
          if (this.$chatbotState.lastRoute === currentRoute || this.$chatbotState.isProcessing) {
            return;
          }

          // 设置处理状态
          this.$chatbotState.isProcessing = true;
          this.$chatbotState.lastRoute = currentRoute;

          console.log('currentRoute', currentRoute);
          // const showPages = ['home', 'my', 'kycHome'];
          const shouldShow = showPages.includes(currentRoute);

          if (shouldShow) {
            this.showChatbot();
          } else {
            this.hideChatbot();
          }

          // 重置处理状态
          setTimeout(() => {
            this.$chatbotState.isProcessing = false;
          }, 100);
        }
      },

      // 生命周期钩子
      mounted() {
        // 全局加载客服插件（只加载一次）
        if (!window.difyChatbotLoaded) {
          this.initChatbot();
        }

        // 根据当前页面决定是否显示
        this.updateChatbotVisibility();
      },

      // 添加全局路由监听，控制显示/隐藏
      watch: {
        '$route'(to, from) {
          this.updateChatbotVisibility();
        }
      }
    });
  }
};
